<div class="modal" *ngIf="!data.specific">
    <div class="modal-content">
      <h2>{{ (data.title || 'modalGeneral.defaultTitle') | translate }}</h2>
      <p [innerHTML]="(data.message || 'modalGeneral.defaultMessage') | translate"></p>
        <div class="actions">
            <button mat-button  
                    class="cancel-button" 
                    (click)="closeModalWithResult(false)"
                    >
                {{ (data.buttonTextCancel || 'modalGeneral.cancel') | translate }}
            </button>
            <button mat-button 
                    (click)="closeModalWithResult(true)"
                    >
                {{ (data.buttonText || 'modalGeneral.confirm') | translate }}
            </button>
        </div>
    </div>
</div>